import {createRequestTypes} from "./helpers";

export const PACKAGES_DATA = createRequestTypes("WAREHOUSE:REQUEST_PACKAGES_DATA");
export const loadPackagesData = (warehouseId, jobs) => ({ type: PACKAGES_DATA.LOAD, warehouseId, jobs });

// Update packages, used on the client side while a call to the server is made
// In some cases, we want to update the package without expecting a return from
// the server, in which case clientSideOnly should be set to true.
export const UPDATE_PACKAGES = "WAREHOUSE:UPDATE_PACKAGES";
export function updatePackages(warehouseId, uids, updater, clientSideOnly = false) {
  return {
    type: UPDATE_PACKAGES,
    warehouseId, uids, updater,
    clientSideOnly,
  }
}

export const UPDATE_JOB = "WAREHOUSE:UPDATE_JOB";
export function updateJob(warehouseId, updatedJob) {
  return {
    type: UPDATE_JOB,
    warehouseId, updatedJob
  }
}
export const ADD_JOB = "WAREHOUSE:ADD_JOB";
export function addJob(warehouseId, newJob) {
  return {
    type: ADD_JOB,
    warehouseId, newJob
  }
}